webpackJsonp([23981196639075],{

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-preview.22b8577a.jpg";

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(24);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _ProjectDetails = __webpack_require__(27);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _ProjectHeader = __webpack_require__(28);
	
	var _ProjectHeader2 = _interopRequireDefault(_ProjectHeader);
	
	var _SingleImage = __webpack_require__(29);
	
	var _SingleImage2 = _interopRequireDefault(_SingleImage);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	var _gumtreePreview = __webpack_require__(466);
	
	var _gumtreePreview2 = _interopRequireDefault(_gumtreePreview);
	
	__webpack_require__(342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gumtree = function (_Component) {
	  _inherits(Gumtree, _Component);
	
	  function Gumtree() {
	    _classCallCheck(this, Gumtree);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Gumtree.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_ProjectHeader2.default, {
	        heading: 'Evolving and optimising Australia\u2019s marketplace'
	      }),
	      _react2.default.createElement(
	        _ProjectDetails2.default,
	        {
	          role: 'User experience designer',
	          client: 'Gumtree Australia',
	          agency: 'Pollen',
	          agencylink: 'https://wwww.pollen.com.au',
	          deliverables: 'User research, user interface design, wireframes, user flows'
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Overview'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'While at ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.pollen.com.au/' },
	            'Pollen'
	          ),
	          ', I\u2019ve had the pleasure of working on a range of projects that have helped shape the user experience of Gumtree Australia, a marketplace that sees over 7 million unique users per month.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Since 2011, Pollen has been working consistently to evolve the online classifieds platform, helping optimise the user experience and later ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.pollen.com.au/case-study/gumtree-rebrand' },
	            'turn over a new leaf with a complete rebrand'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePreview2.default }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Working closely with Gumtree product and marketing teams, I\u2019ve helped optimise the interaction, design and content of pages across the site.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\u2019ve explored new ways to streamline the processes of selling an item and performing multiple searches.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\u2019ve also helped conduct user testing sessions with Gumtree buyers and sellers for a range of different products and features.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Last but not least, I helped ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/gumtree-paypal' },
	            'integrate peer-to-peer payments to the Gumtree platform'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\u2019ve been one very small set of hands involved in the evolution of the Gumtree platform. The work that Pollen has done, particularly the new rebrand, has been received exceptionally well by the Australian public and the team at Gumtree Australia.'
	        )
	      )
	    );
	  };
	
	  return Gumtree;
	}(_react.Component);
	
	Gumtree.propTypes = {
	  children: _react.PropTypes.node.isRequired
	};
	
	exports.default = Gumtree;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-gumtree-index-js-9b53d2d4adcb6331f8da.js